import Axios from 'axios';

const RESOURCE = '/orgs';

export default {
  /**
   * @param {String} appId is a unqiue org id
   */
  getAccountData() {
    return Axios.get(`${RESOURCE}/dunning/customer`);
  },

  /**
   * @param {String} appId is a unqiue org id
   */
  getSetupIntent() {
    return Axios.get(`${RESOURCE}/dunning/billing`);
  },

  getDemoSetupIntent({ stripeAccountId }) {
    return Axios.post(`${RESOURCE}/dunning/demo-setup-intent`, {
      stripeAccountId,
    });
  },

  /**
   * @param {String} paymentMethodId is the new card id
   */
  chargeBalanceToCard(paymentMethodId) {
    return Axios.post(`${RESOURCE}/dunning/billing`, paymentMethodId);
  },

  /**
   * @param {String} paymentMethodId is the new card id
   */
  reactivate(paymentMethodId) {
    return Axios.post(`${RESOURCE}/dunning/reactivate`, paymentMethodId);
  },

  /**
   * @returns {Boolean} true if successful
   */
  cancelIncompleteSubscriptions() {
    return Axios.post(`${RESOURCE}/dunning/cancel-incomplete-subscriptions`);
  },

  /**
   * @param {String} domain is the domain for the checkout page
   * @param {String} orgId (optional) orgId to help identify the correct org when multiple orgs share domains
   */
  checkOrgDomain(domain, orgId = null) {
    const url = orgId
      ? `${RESOURCE}/dunning/checkout/${domain}?orgId=${orgId}`
      : `${RESOURCE}/dunning/checkout/${domain}`;
    return Axios.get(url);
  },
};
